import React, { useEffect } from "react";
import { CircularProgress, AlertBanner, Error } from "Components/shared/oneui";
import NoDowntime from "./NoDowntime";
import { getFormattedDate, getFormattedTime } from "Utils/common";
import RefreshBtn from "./RefreshBtn";

const ActiveDowntime = (props) => {
  const {
    downtimeListFetching,
    downtimeListError,
    downtimeList,
    updateFilter,
    show,
  } = props;
  useEffect(() => {
    if (!show) return;
    updateFilter({
      isCurrentlyDown: true,
      pageOffset: 0,
    });
  }, [show]);

  if (downtimeListFetching) {
    return (
      <div className=" twside-flex twside-justify-center twside-items-center twside-h-400">
        <CircularProgress variant="BLOCK" label="Please wait, loading..." />
      </div>
    );
  }
  if (downtimeListError) {
    return (
      <div className="twside-flex twside-justify-center twside-items-center twside-h-400">
        <Error
          className="twside-p-16"
          actions={[
            {
              icon: "retry",
              onClick: () =>
                updateFilter({
                  isCurrentlyDown: true,
                  pageOffset: 0,
                }),
              text: "Try Again",
              variant: "RETRY",
            },
          ]}
          description={{
            props: {
              className: "twside-text-green-gray-300",
              variant: "P2",
              weight: "medium",
            },
            text: "An error occurred while loading the data, please retry",
          }}
          heading={{
            props: {
              className: "twside-text-gray-900 twside-text-center",
              variant: "H3",
              weight: "semi-bold",
            },
            text: "Oops! Something went wrong",
          }}
          imageProps={{
            className: "twside-bg-blue-50 twside-w-[150px]",
            type: "server-error",
          }}
          message={{
            props: {
              className: "twside-text-green-gray-300",
              variant: "SH3",
              weight: "medium",
            },
            text: "SERVER ERROR",
          }}
        />
      </div>
    );
  }
  return (
    <>
      {downtimeList.length > 0 ? (
        <>
          <div>
            {downtimeList.map((downtime) => (
              <AlertBanner
                className="twside-mb-12"
                alertIconProps={{
                  "data-testid": "alert-banner-icon",
                  iconName: "warning",
                  size: "m",
                  variant: "filled",
                }}
                headingProps={{
                  "data-testid": "alert-banner-heading",
                  heading: `${downtime.category} - ${downtime.bankName} is down`,
                  className:
                    "twside-text-green-gray-800 twside-text-14 twside-font-medium",
                }}
                data-testid="alert-banner-component"
                descriptionProps={{
                  "data-testid": "alert-banner-description",
                  className:
                    "twside-text-green-gray-300 twside-text-14 twside-font-medium",
                  text: `since ${getFormattedTime(
                    downtime.downSinceTime
                  )} ${getFormattedDate(downtime.downSinceTime)}`,
                }}
                theme="WARNING"
              />
            ))}
          </div>
          <div className="twside-text-center twside-py-8">
            <div className="twside-hidden t:twside-block twside-py-4 twside-px-16 twside-mt-4">
              <RefreshBtn updateFilter={updateFilter} />
            </div>
            {show && (
              <div className="t:twside-hidden twside-fixed twside-bottom-0 twside-w-full twside-text-center twside-ml-[-16px]">
                <RefreshBtn isMobile={true} updateFilter={updateFilter} />
              </div>
            )}
          </div>
        </>
      ) : (
        <NoDowntime show={show} updateFilter={updateFilter} />
      )}
    </>
  );
};

export default ActiveDowntime;
